var CompleteRegistrationEnum = /* @__PURE__ */ ((CompleteRegistrationEnum2) => {
  CompleteRegistrationEnum2["COMPLETE_REGISTRATION_GENDER_FEMALE_RADIO"] = "radio-female-value";
  CompleteRegistrationEnum2["COMPLETE_REGISTRATION_GENDER_MALE_RADIO"] = "radio-male-value";
  CompleteRegistrationEnum2["COMPLETE_REGISTRATION_GENDER_NONBINARY_RADIO"] = "radio-nonbinary-value";
  CompleteRegistrationEnum2["COMPLETE_REGISTRATION_GENDER_NOT_INFORMED_RADIO"] = "radio-not_informed-value";
  return CompleteRegistrationEnum2;
})(CompleteRegistrationEnum || {});
export {
  CompleteRegistrationEnum
};
